import { User } from '@choco-admin/types';
import { Button } from '@heroui/react';
import React from 'react';
import { FiArrowLeft, FiUser } from 'react-icons/fi';

import { UserStatus } from '../../../../../components/UserStatus';

interface UserProfileHeaderProps {
  user: User;
  onBack: () => void;
}

export const UserProfileHeader: React.FC<UserProfileHeaderProps> = ({
  user,
  onBack,
}) => {
  return (
    <div className="flex items-center gap-4">
      <Button
        variant="flat"
        color="default"
        startContent={<FiArrowLeft className="h-4 w-4" />}
        onPress={onBack}
      >
        Back to Users
      </Button>
      <div className="flex items-center gap-3">
        <div className="p-2 bg-primary-100 rounded-full">
          <FiUser className="h-6 w-6 text-primary-600" />
        </div>
        <div>
          <h1 className="title-large">{user.name || 'Unknown User'}</h1>
          <div className="flex items-center gap-2 mt-1">
            <UserStatus
              hasRequestedToBeDeleted={user.hasRequestedToBeDeleted}
              pending={user.pending || false}
              size="sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
